export default {
  data(){
    return {
      travelers: [],
    }
  },
  methods: {
    search_travelers(){
      // this.$http.get('/api/user/').then(response => {
      //   if (response.status === 200) {
      //     // this.travelers = ;
      //     for (let traveler of response.data.results){
      //       this.get_traveler(traveler.id)
      //     }
      //   }
      // }).catch(error => {
      //   console.log(error)
      // })
      this.travelers = []
      this.$http({
        url: "/api/user/travelers/parent",
        method: "GET"
      }).then(response => {
        let data = response.data;
        for (let traveler of response.data){
          this.travelers.push({'id': traveler.id, 'full_name': traveler.name, 'birthdate': traveler.birthdate, 'label': traveler.name, 'document_number': traveler.document_number, 'email': traveler.email })
        }
        this.$emit('refreshtraveler', this.travelers);
        // this.travelers = _.sortBy(data, "name");
        // this.travelers.unshift({ id: null, name: "Selecione o viajante" });
        // this.traveler = this.travelers[0].id;
      });
    },
    get_traveler(id){
      this.$http.get('/api/user/', {params: {id: id}}).then(response => {
        if (response.status === 200) {
          this.travelers.push(response.data);
        }
      }).catch(error => {
        console.log(error)
      })
    },
    verify_travelers() {
      let adults = 0
      let infants = 0
      let children = 0
      let type_age = ''
      let verify = false
      Object.keys(this.flight.travelers).forEach((vl) => {
        if (this.flight.travelers[vl].id){
          verify = false
          Object.keys(this.travelers).forEach((vl2) => {
            if (this.flight.travelers[vl].id == this.travelers[vl2].id && !verify){
              type_age = this.verify_type_age(this.travelers[vl2].birthdate, this.flight.date_outbound, this.flight.date_inbound)
              if (type_age == 'infants'){
                infants += 1
              }
              if (type_age == 'children'){
                children += 1
              }
              if (type_age == 'adults'){
                adults += 1
              }
              verify = true
            }
          })
        }

      })

      return this.dependents_compare_is_error(adults, children, infants)
    },
    verify_type_age(birthdate, outbound, inbound){

      //let years_maximum = 0
      //const dateParts = birthdate.split("/");
      let date_birthdate = new Date(birthdate);
      let date_verify = new Date((inbound ? inbound : outbound))
      let type_age = ''
      let msg_error = ''

      let ageTraveler = new Date(date_verify - date_birthdate)
      ageTraveler = (Math.abs(ageTraveler.getUTCFullYear() - 1970))

      if (ageTraveler < 2){
        type_age = 'infants'
      }else if (ageTraveler < 12){
        type_age = 'children'
      }else{
        type_age = 'adults'
      }

      return type_age

    },
    convert_type_age_br(str_convert){
      // str_converted = str_convert
      let str_converted = ''
      if (str_convert == 'adults'){
        str_converted = 'Adulto'
      }else if (str_convert == 'children'){
        str_converted = 'Criança'
      }else if (str_convert == 'infants'){
        str_converted = 'Bebê'
      }

      return str_converted
    },
    dependents_compare_is_error(adults, children, infants){

      const total_travelers_flight = this.flight.adults + this.flight.children + this.flight.infants
      const total_travelers_selected = adults + children + infants
      let msg_error = ''

      //if (total_travelers_flight == total_travelers_selected){
        if (adults != this.flight.adults || children != this.flight.children || infants != this.flight.infants){

          if (this.flight.adults > 0){
            msg_error += (msg_error == '' ? 'Deverá selecionar ': ', ')
            msg_error += this.flight.adults + ' adulto(s)'
          }

          if (this.flight.children > 0){
            msg_error += (msg_error == '' ? 'Deverá selecionar ': ', ')
            msg_error += this.flight.children + ' criança(s)'
          }

          if (this.flight.infants > 0){
            msg_error += (msg_error == '' ? 'Deverá selecionar ': ' e ')
            msg_error += this.flight.infants + ' bebê(s)'
          }

        }
      //}
      return (msg_error == '' ? false: msg_error)
    }
  }
}
